<template>
  <v-chip outlined :small="small">
    <span v-if="!small">{{ $lang('main.words.rating') }}</span>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">
        <v-btn @click="handleInput(1)" icon :small="small">
          <v-icon v-if="isPositive" color="green" :small="small">mdi-thumb-up</v-icon>
          <v-icon v-else color="grey" :small="small">mdi-thumb-up-outline</v-icon>
        </v-btn>
        <v-btn @click="handleInput(-1)" icon :small="small">
          <v-icon v-if="isNegative" color="red" :small="small">mdi-thumb-down</v-icon>
          <v-icon v-else color="grey" :small="small">mdi-thumb-down-outline</v-icon>
        </v-btn>
        </span>
      </template>
      <span>{{ $lang('tickets.hints.rating') }}</span>
    </v-tooltip>
  </v-chip>
</template>

<script>
export default {
  props: {
    value: {
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      rating: this.value
    }
  },
  methods: {
    handleInput (val) {
      if (this.readonly) return;

      this.$emit('input', val)
    },
  },
  computed: {
    isPositive() {
      return this.value === 1;
    },
    isNegative() {
      return this.value === -1;
    }
  },
}
</script>